import { render, staticRenderFns } from "./TopFilter.vue?vue&type=template&id=dd566dc0&"
import script from "./TopFilter.vue?vue&type=script&lang=js&"
export * from "./TopFilter.vue?vue&type=script&lang=js&"
import style0 from "./TopFilter.vue?vue&type=style&index=0&id=dd566dc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FilterSizes: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/FilterSizes.vue').default,FilterColors: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/FilterColors.vue').default,FilterPrice: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/FilterPrice.vue').default})
